import type { InputHTMLAttributes, ReactNode } from "react";

export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  /** Optional leading glyph rendered inside the input (e.g. a user/lock icon on the login form). */
  icon?: ReactNode;
}

/** A labelled text input — the form-field vocabulary. Token-styled. */
export function Field({ label, icon, ...rest }: FieldProps) {
  return (
    <label className="fui-field">
      <span className="fui-field__label">{label}</span>
      {icon ? (
        <span className="fui-field__control">
          <span className="fui-field__icon" aria-hidden="true">
            {icon}
          </span>
          <input className="fui-field__input fui-field__input--with-icon" {...rest} />
        </span>
      ) : (
        <input className="fui-field__input" {...rest} />
      )}
    </label>
  );
}
